import React, {Component} from 'react';
import { HeadingSmall, ParagraphLarge } from 'baseui/typography';
import { ListItem, ListItemLabel } from "baseui/list";
import { Check } from "baseui/icon";
import password_light from '../images/categories/passwords/password_light.svg';
import file_light from '../images/categories/files/file_light.svg';
import cc_light from '../images/categories/credit_cards/cc_light.svg';
import id_light from '../images/categories/id_cards/id_light.svg';
import address_light from '../images/categories/addresses/address_light.svg';
import notes_light from '../images/categories/notes/notes_light.svg';
import { FlexGrid, FlexGridItem } from 'baseui/flex-grid';
import { StyledLink } from 'baseui/link';
import * as ROUTES from '../Routes';

const centerProps = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

class About extends Component {
    constructor(props) {
        super(props);

        this.state = {
            short: this.props.short ? this.props.short : false
        }
    }

    renderInformationCategories = () => {
        return <ul
            style={{
                minWidth: '300px',
                width: '600px',
                maxWidth: '800px',
                paddingLeft: 0,
                paddingRight: 0,
            }}
        >
            <ListItem
                artwork={props => <img alt={''} width={'32px'} src={password_light}/>}
                endEnhancer={() => (<Check
                    size={32}
                    overrides={{
                        Svg: {
                            style: ({ $theme }) => ({
                                color: $theme.colors.primaryA
                            })
                        }              
                    }}
                    />)}
            >
                <ListItemLabel description="Password, username, email, URL, notes.">Passwords</ListItemLabel>
            </ListItem>
            <ListItem
                artwork={props => <img alt={''} width={'32px'} src={file_light}/>}
                endEnhancer={() => (<Check
                    size={32}
                    overrides={{
                        Svg: {
                            style: ({ $theme }) => ({
                                color: $theme.colors.primaryA
                            })
                        }              
                    }}
                />)}
            >
                <ListItemLabel description="File, name, password, notes.">Files</ListItemLabel>
            </ListItem>
            <ListItem
                artwork={props => <img alt={''} width={'32px'} src={cc_light}/>}
                endEnhancer={() => (<Check
                    size={32}
                    overrides={{
                        Svg: {
                            style: ({ $theme }) => ({
                                color: $theme.colors.primaryA
                            })
                        }              
                    }}
                />)}
            >
                <ListItemLabel description="Credit card, pin, bank account, notes.">
                Credit Cards
                </ListItemLabel>
            </ListItem>
            <ListItem
                artwork={props => <img alt={''} width={'32px'} src={id_light}/>}
                endEnhancer={() => (<Check
                    size={32}
                    overrides={{
                        Svg: {
                            style: ({ $theme }) => ({
                                color: $theme.colors.primaryA
                            })
                        }              
                    }}
                />)}
            >
                <ListItemLabel description="Government, insurance, or any other IDs.">ID Cards</ListItemLabel>
            </ListItem>
            <ListItem
                artwork={props => <img alt={''} width={'32px'} src={address_light}/>}
                endEnhancer={() => (<Check
                    size={32}
                    overrides={{
                        Svg: {
                            style: ({ $theme }) => ({
                                color: $theme.colors.primaryA
                            })
                        }              
                    }}
                />)}
            >
                <ListItemLabel description="Address, notes.">Addresses</ListItemLabel>
            </ListItem>
            <ListItem
                artwork={props => <img alt={''} width={'32px'} src={notes_light}/>}
                endEnhancer={() => (<Check
                    size={32}
                    overrides={{
                        Svg: {
                            style: ({ $theme }) => ({
                                color: $theme.colors.primaryA
                            })
                        }              
                    }}
                />)}
            >
                <ListItemLabel>Notes</ListItemLabel>
            </ListItem>
        </ul>
    };

    renderAbout = () => {
        return <div>
            <FlexGrid backgroundColor={'primaryB'} style={{padding: '20px'}}>
                <FlexGridItem><HeadingSmall margin={0}>What is EncLock</HeadingSmall></FlexGridItem>
                <FlexGridItem>
                    <ParagraphLarge>
                    EncLock is a free, privacy-focused security app that helps you securely store and manage your most sensitive personal data. While it's commonly categorized as a Password Manager, EncLock goes far beyond that.
                    </ParagraphLarge>
                    <ParagraphLarge>
                    With support for multiple categories—like passwords, files, notes, credit cards, and more—you can organize all your private information in one encrypted vault. Create folders, search easily, and rearrange your entries whenever you need.
                    </ParagraphLarge>
                    <ParagraphLarge>
                    Everything you store in EncLock is protected with AES-256 bit encryption, a trusted industry standard for securing data—ensuring your information stays safe, private, and accessible only to you.
                    </ParagraphLarge>
                </FlexGridItem>
            </FlexGrid>

            <FlexGrid>
                <FlexGridItem {...centerProps}><HeadingSmall>Storage categories</HeadingSmall></FlexGridItem>
                <FlexGridItem {...centerProps}>{this.renderInformationCategories()}</FlexGridItem>
            </FlexGrid>
        </div>
    };

    renderShortAbout = () => {
        return <FlexGrid>
            <FlexGridItem>
                <FlexGrid backgroundColor={'primaryB'} style={{padding: '20px'}}>
                    <FlexGridItem><HeadingSmall margin={0}>What is EncLock</HeadingSmall></FlexGridItem>
                    <FlexGridItem>
                        <ParagraphLarge>
                        EncLock is a free security app that helps you securely store and manage your most sensitive personal information. 
                        Everything you save is protected with advanced, industry-standard AES-256 bit encryption. <StyledLink href={ROUTES.ABOUT}>Read more.</StyledLink>
                        </ParagraphLarge>
                    </FlexGridItem>
                </FlexGrid>
            </FlexGridItem>
        </FlexGrid>
    };

    render = () => {
        return this.state.short ? this.renderShortAbout() : this.renderAbout();
    };
}

export default About;
